import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const DemoLogin: React.FC = () => {
  const { user, loginAsDemo } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [attempted, setAttempted] = useState(false);

  useEffect(() => {
    if (user || attempted) return;
    setAttempted(true);
    loginAsDemo().catch((e: any) => {
      setError(e?.message || 'Demo login failed');
    });
  }, [user, attempted, loginAsDemo]);

  if (user) return <Navigate to="/" replace />;

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      flexDirection: 'column',
      gap: '16px'
    }}>
      <img
        src="/revenue-social-logo.svg"
        alt="Revenue Social"
        style={{ height: '64px', width: 'auto' }}
      />
      {error ? (
        <div style={{
          maxWidth: '400px',
          padding: '20px',
          backgroundColor: '#fef2f2',
          borderRadius: '12px',
          border: '1px solid #fecaca',
          color: '#dc2626',
          textAlign: 'center'
        }}>
          <p style={{ margin: '0 0 8px 0', fontWeight: 600 }}>Couldn't start the demo</p>
          <p style={{ margin: 0, fontSize: '13px' }}>{error}</p>
          <p style={{ margin: '12px 0 0 0', fontSize: '13px' }}>
            <a href="/login" style={{ color: '#2563eb' }}>Back to login</a>
          </p>
        </div>
      ) : (
        <p style={{ color: '#1e40af', fontSize: '15px', margin: 0 }}>
          Loading the demo…
        </p>
      )}
    </div>
  );
};

export default DemoLogin;
